import React, { useEffect, useState } from 'react';
import { StakingTitle } from '../../components/StakingTitle';
import { LiquidityMiningPool } from '../../components/LiquidityMiningPool';
import { useSelector } from 'react-redux';
import { getProjectConfig } from '../../ducks/project/selectors';
import { getNetworkName } from '../../sdk/helpers/network';
import { LMInterface } from '../../types/dto/Project.dto';
import { loadV1 } from '../LiquidityMiningPool/loadLMCV1';
import { loadV2 } from '../LiquidityMiningPool/loadLMCV2';
import { PoolVersions } from '../../utils/helpers';

export const LiquidityMiningPoolList: React.FC<{
  title: string;
  subTitle: string;
  filter: (pool: LiquidityMiningPool) => boolean;
}> = (props) => {
  const [pools, setPools] = useState<(LiquidityMiningPool | null)[]>([]);
  const [loading, setLoading] = useState(true);

  const config = useSelector(getProjectConfig);

  const load = async (): Promise<void> => {
    if (!config) return;

    setLoading(true);

    const currentNetwork = await getNetworkName();
    const campaigns = config.campaignsLM?.filter((item: LMInterface) => item.network === currentNetwork) || [];

    async function loadCampaign(campaign: LMInterface): Promise<LiquidityMiningPool | null> {
      try {
        if (!campaign.version || campaign.version === PoolVersions.v1) {
          return await loadV1(campaign);
        }

        if (
          campaign.version === PoolVersions.v2 ||
          campaign.version === PoolVersions.v3 ||
          campaign.version === PoolVersions.v4
        ) {
          return await loadV2(campaign);
        }
      } catch (e) {
        console.error(e);
      }

      return null;
    }

    const promises = campaigns.map(loadCampaign);

    Promise.all(promises).then((pools) => {
      setPools(pools);
      setLoading(false);
    });
  };

  useEffect(() => {
    let shouldLoad = true;

    if (shouldLoad) {
      load();
    }

    return (): void => {
      shouldLoad = false;
    };
  }, [config]);

  return (
    <React.Fragment>
      <StakingTitle title={props.title} hideInfo={true} message={props.subTitle} showRefresh={true} onRefresh={load} />
      <div className="pools">
        {!loading &&
          pools
            .filter((pool) => pool && props.filter(pool))
            .map(
              (pool, poolIndex) =>
                pool && (
                  <div key={poolIndex}>
                    <LiquidityMiningPool pool={pool} />
                  </div>
                ),
            )}
        {loading && <div className="pools-loading">Loading...</div>}
      </div>
    </React.Fragment>
  );
};
